module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sections) ? _c('section', {
    staticClass: "collection-story underline-links"
  }, _vm._l((_vm.sections), function(block, index) {
    return (_vm.showBlock(block)) ? _c(_vm.setBlock('layout', block.getText('layout')), {
      key: index,
      tag: "component",
      staticClass: "collection-story--block",
      attrs: {
        "variant": _vm.setBlock('variant', block.getText('layout')),
        "header": block.getText('header'),
        "text": _vm.html(block, 'text'),
        "imageUrl": _vm.getLandscapeImageUrl(block),
        "imageAlt": block.getText('text'),
        "imageTableHeader": block.getText('image-table--header'),
        "imageTableText": _vm.html(block, 'image-table--text'),
        "imagesetId": block.data.imageset ? block.data.imageset.value.document.id : null,
        "mobile": _vm.mobile,
        "window": _vm.window
      }
    }) : _vm._e()
  }), 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ccedb7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collection__Story.vue
// module id = 377
// module chunks = 1